// client/src/pages/ImpressumPage.jsx
import React from "react";
import LegalLayout from "./LegalLayout.jsx";
import LegalPageBody from "./LegalPageBody.jsx";

export default function ImpressumPage() {
  return (
    <LegalLayout pageKey="impressum">
      {({ lang }) => <LegalPageBody slug="impressum" lang={lang} />}
    </LegalLayout>
  );
}
